import { Box, Chip, IconButton, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";

const AssetTagManager = ({ tags, setTags }) => {
    const [newTag, setNewTag] = useState("");

    const addTag = () => {
        const trimmed = newTag.trim().toLowerCase();
        if (trimmed && !tags.includes(trimmed)) {
            setTags([...tags, trimmed]);
        }
        setNewTag("");
    };

    const removeTag = (tagToRemove) => {
        setTags(tags.filter(t => t !== tagToRemove));
    };

    return (
        <>
            <Box display="flex" alignItems="center">
                <TextField
                    label="Add Tag"
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                    size="small"
                />
                <IconButton onClick={addTag}><AddIcon /></IconButton>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {tags.map(tag => (
                    <Chip key={tag} label={tag} onDelete={() => removeTag(tag)} deleteIcon={<DeleteIcon />} />
                ))}
            </Box>
        </>
    );
};

export default AssetTagManager;
